<template>
	<div class="px-5">
		<app-table
			class="mt-3 table-rows no-main-list"
			name="roles-access-resources"
			:columns="columns"
			:check-all="checkAll"
			:rows="rows"
			:main-list="false"
			selectable
			@on-search-event="onSearch"
			@row-is-selected="rowIsSelected"
			@on-selected-all="allIsSelected"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.uri }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.resource }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.module }}
				</td>
				<td v-show="showRow(columns, 5)">
					<v-text-field
						class="body-1 mx-auto input-small mt-2"
						hide-details
						min="0"
						required
						small
						solo
						type="number"
						:disabled="disabledInput(props.row)"
						v-model.number="props.row.configPosition"
						@blur="updatePosition(props.row)"
					>
					</v-text-field>
				</td>
				<td v-show="showRow(columns, 6)">
					{{ props.row.statusName }}</td>
				<td>
					<app-tooltip-button
						color="primary"
						icon="settings"
						text="Configurar Recurso"
						@click-icon="openSettings(props.row.id)"
					/>
					<app-tooltip-button
						color="green"
						icon="sort"
						text="Agregar Subrecursos"
						@click-icon="openSubresources(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="touch_app"
						text="Barra de Acciones"
						@click-icon="openActions(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="cloud_queue"
						text="Servicios"
						@click-icon="$emit('open-services', props.row)"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function allIsSelected(checked) {
	this.$emit('all-is-selected', checked);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openSettings(value) {
	this.$emit('open-settings', value);
}

function openSubresources(row) {
	this.$emit('open-subresources', row);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function disabledInput({ configLanguages }) {
	return !configLanguages;
}

function openActions(value) {
	this.$emit('open-actions', value);
}

async function updatePosition({ id, configPosition }) {
	const position = configPosition;
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		await this.$http.post(`project/${this.codeProject}/company/${this.codeCompany}/resources`,
			{ id, position }, { headers });
		this.showNotification('La posición ha sido cambiada correctamente.');
	} catch (err) {
		this.showError();
	}
}

export default {
	name: 'role-access-resource-list',
	components: {
		appTooltipButton,
	},
	props: {
		codeCompany: {
			type: String,
		},
		codeProject: {
			type: String,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		checkAll: {
			default: false,
			type: Boolean,
		},
		checkRow: {
			default: false,
			type: Boolean,
		},
	},
	methods: {
		allIsSelected,
		disabledInput,
		onSearch,
		openSettings,
		openSubresources,
		openActions,
		rowIsSelected,
		updatePosition,
	},
};
</script>





// WEBPACK FOOTER //
// src/components/roles/role-access-resource-list.vue